<template>
    <div id="personal_intru">
        <div class="close-btn">
            <button @click="close"><v-img src="@/assets/img/closeButton2.svg"></v-img></button>
        </div>
        <div class="content-wrap">
            <div class="title"><p>이 꿈은 갑자기 제 머릿속으로 쏙 들어온 꿈임을 명시합니다.</p></div>
            <div class="content">
 [A : 저 지폐 뭉치가 갑자기 제 가방으로 쏙 들어왔어요.] 
<br>
<br>
이 말은 거짓말입니까? 예 / 아니오
<br>
<br>
[B : 바람이 불어서 나뭇잎이 갑자기 제 가방 속으로 쏙 들어왔어요.]
<br>
<br>
이 말은 거짓말입니까? 예 / 아니오
<br>
<br>
둘 다 우연에 기대어 일어난 일이다. 하지만 나뭇잎을 훔쳤다는 판결을 받기는 꽤 어렵다. 돈을 훔쳤다는 판결을 받기는 쉽다. 첫 번째 사례의 경우 대부분의 사람이 A의 진술을 믿지 않을 것이다. 지폐에는 값어치가 있고, 값어치가 있는 것들은 주인이 있고, 값어치가 있는 것들의 주인은 도둑맞기를 싫어하기 때문이다. 두 번째 사례의 경우, 대부분의 사람은 이런 일에 관심이 없다.
<br>
<br>
첫 번째 사례의 은행 직원은 정면에 있는 CCTV 덕분에 누명을 벗었다. 지폐 뭉치는 책상에서 미끄러져서 책상 아래의 가방으로 혼자 쏙 들어갔다. 그렇기 때문에 직원은 돈을 훔친 것이 아니다. 
<br>
<br>
그러니까 이리에도 남의 꿈을 훔친 것은 아니다. 어쩌다가 목격한 것이지. 그렇다면 목격한 건 무엇을 기점으로 ‘훔쳐봤다’가 될까? 
<br>
<br>
“변화를 일으킬 목적으로 눈앞의 것을 지켜보겠다는 마음을 먹을 때.”
<br>
<br>
김이리에는 꽤 명료한 정의를 내린 채였다. 훔쳐보는 것에는 조금 더 능동적인 의지가 있다. 상대의 무방비한 상태를 지켜보기 위해서 몸을 숨기거나 더 잘 보려는 인위를 가하는 것이다.
<br>
<br>
“그런 적 있어?”
<br>
<br>
“일부러 어떤 상자를 찾아서 열었어. 그 안에 뭐가 있는지 확인해야 했거든.”
<br>
<br>
이리에가 손등으로 턱을 괴고 나를 봤다. 그리고는 의도를 담아 눈을 깜빡거렸다. 무슨 뜻인지 알아서 고맙고, 애틋하고, 꼴 보기 싫었다.
<br>
<br>
<br>
<br>


“연구자 1은 어떤 꿈을 꾸는지 궁금해요.”
<br>
<br>
연구자 3이 이리에한테 물었다. 함께 드림 네트워크 사이트를 들여다보던 중이었다. 
<br>
<br>
“저도 이미 사이트에 남겼어요.”
<br>
<br>
“정말요?” 연구자 3은 기쁜 방식으로 놀랐다. 무관심해보이더니 언제 그런 걸 다 남겼냐는 듯한 눈빛이었다.
<br>
<br>
“아니에요. 개쌉거짓말이에요.”
<br>
<br>
내가 연구자 3에게 걔 대신 대답해줬다. 김이리에는 음향원을 떠난 이후로 꿈을 꾸지 않는다. 남의 꿈도 꾸지 않는다. 단지 가끔 타인의 꿈에 관한 환청을 듣는다.
<br>
<br>
“정말이에요. 만두 꿈도 쓰고 초콜릿 꿈도 썼어요.”
<br>
<br>
“거짓말. 그건 다 제 거예요.”
<br>
<br>
선량한 얼굴로 남의 꿈을 도난하는 김이리에를 노려봤다. 그러자 걔가 히히 웃었다. 
<br>
<br>
“저는 꿈 안 꿔요. 근데 남의 꿈 훔쳐 꿨던 장물은 좀 있어요. 그거라도 올릴까요.”
<br>
<br>
“남의 꿈인 건 어떻게 알아요?”
<br>
<br>
연구자 3이 그렇게 묻자 김이리에는 ‘<span class="sound_text_visited" :class="{'sound-text' : visited[49] === 'disabled'}" @click="play('맵')">미생성된 맵</span> 이탈론’을 설명해줬다. 타인의 꿈 말로에서는 꼭 추락한다는 법칙이었다. 쫓겨나는 것처럼 말이다. 
<br>
<br>
“그럼 꿈속에서 꿈 주인을 만난 적도 있어요?”
<br>
<br>
“네. 가끔 엑스트라도 해줬어요. <span class="sound_text_visited" :class="{'sound-text' : visited[50] === 'disabled'}" @click="play('거울')">꿈에는 거울이 없어서</span> 정확히 어떤 분장인지는 잘 모르겠는데….”
<br>
<br>
<br>
<br>

분홍색 단발머리를 한 문학 선생님을 만났다. 선생님은 큰 새를 타고 바다 위의 하늘을 날아다녔다. 햇볕이 뜨거워지면 커다란 배로 돌아가서 <span class="sound_text_visited" :class="{'sound-text' : visited[51] === 'disabled'}" @click="play('햇볕')">쉬는 것 같았다.</span> 역시 이카루스 이야기를 알고 계시기 때문일까? <br>
나는 그 배에서 일하는 선원이었다. 선생님, 분홍색 단발머리가 잘 어울려요. 말하려다가 어울리는 대사가 아닌 것 같아 기각했다. <br>
이 꿈은 커다란 새를 훔쳐 타려다가 끝이 났다. 꾸벅꾸벅 졸다가 날아오른 새가 뒤늦게 내 얼굴을 확인했다. 그리고 화가 난 것처럼 크게 날개를 휘저었다. 나는 추락했고, 선생님은 바다 속을 따로 상상해놓지 않았기 때문에 그대로 현실에 돌아왔다.   <br>
<br>
<br>
<br>
<br>

지각할 뻔했다. 그런데 지각하지 않았다.<br>
왜냐하면 꿈의 주인도 어쩔 수 없는 음향원 학생이었기 때문이다.<br>
나는 줄을 서있는 사람들 중 하나였다. 모두가 감독관을 기다리고 있었다. 그의 지시에 따라 사람들은 세 개의 컨베이어 벨트로 나뉘어 보내졌다. 기준은 잘 알 수 없었다.<br>
나보다 네 명 정도 앞선 사람은 뒷목에 점이 있었다. 점이 여러 개 있었다. 감독관은 그걸 펜으로 이어보고 <span class="sound_text_visited" :class="{'sound-text' : visited[52] === 'disabled'}" @click="play('고개')">고개를 끄덕였다.</span><br>
<br> 
나에게는 "눈을 똑바로 떠보라"고 했다. 눈을 뜨고 있는 건 확실했다. 앞이 보였으니까. 하지만 푸른 멜빵바지를 입은 감독관은 자꾸 "그렇게는 아닙니다. 다르게요. <span class="sound_text_visited" :class="{'sound-text' : visited[53] === 'disabled'}" @click="play('다르게')">다르게.</span>" 라고 다그쳤다. 마지막으로는 한숨을 쉬고 나를 중간 컨베이어 벨트에 실어 보냈다.<br>
벨트가 너무 길어서 초조해지기 시작했다. 이대로 기다리다가는 음향원에 지각할 것 같았기 때문이다. 다행히 곧 벨트가 뒤집히면서 추락했다. 평소보다 15분 늦게 깨어났다. 꿈의 주인이 원망스러웠지만, 그래도 함께 지각은 면했다.
<br>
<br>

            </div>
        </div>
    </div>
</template>
<script>
import eventBus from '@/plugins/eventbus.js'
import store from "@/store/index.js";

export default {
  name: 'index_thirteen',
  data() {
    return {
        visited : {
            49: store.getters['getMusicIconUsable'](49),
            50: store.getters['getMusicIconUsable'](50), 
            51: store.getters['getMusicIconUsable'](51),
            52: store.getters['getMusicIconUsable'](52),
            53: store.getters['getMusicIconUsable'](53),
        },
        
    }
  },
  methods: {
    close() {
        this.$emit("btnclose");
    },
    play(message) {

        switch(message) {
            case '맵' :      
                store.commit("toggleText", 49)
                eventBus.$emit("iconUsable", 49); 
                this.visited[49] = 'active';
                break; 
            case "거울" :
                store.commit("toggleText", 50)
                eventBus.$emit("iconUsable", 50); 
                this.visited[50] = 'active';
                break;
            case "햇볕" :
                store.commit("toggleText", 51)
                eventBus.$emit("iconUsable", 51); 
                this.visited[51] = 'active';
                break;
            case "고개" :
                store.commit("toggleText", 52)
                eventBus.$emit("iconUsable", 52); 
                this.visited[52] = 'active';
                break;
            case "다르게" :
                store.commit("toggleText", 53)
                eventBus.$emit("iconUsable", 53); 
                this.visited[53] = 'active';
                break;
        }
    }
  }
}
</script>

<style scoped>
::-webkit-scrollbar {
display: none;
}

#personal_intru {
  box-sizing: border-box;

  position: absolute;
  height: 649px;
  width: 500px;

  border-radius: 20px;
  border: 1px solid rgba(0, 0, 0, 0.6);

  background: rgba(26, 26, 26, 0.9);
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(40px);
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 20px;

  left: 406px;
  top: 800px;

  text-align: center;
}

.close-btn {
    position: relative;
    height: 16px;
    width: 16px;
    left: 16px;
    top: 16px;
    border-radius: 16px;
}

.content-wrap {
    position : relative;

    left: 60px;
    top: 64px;
    height: 569px;
    width: 380px;

    overflow-y: scroll;
}

.title {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    /* identical to box height */

    text-align: center;

    color: #F1F1F1;

}

.content {
    margin-top: 58px;

    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 200%;
    /* or 36px */

    text-align: justify ;
    color: #F1F1F1;

}

@media (max-width: 600px) {

    #personal_intru {
        top: 500px;
        left: 0;
        width: 100vw;
        height: 600px;
        
    }

    .content-wrap {
        left: 45px;
        width: 310px;
        height: 510px;
    }
    
    .title {
        font-weight: 700;
        font-size: 18px;
        line-height: 22px;
        color: #EAEAEA;


    }

    .content {
        width: 310px;
        height: 510px;
        font-weight: 600;
        font-size: 14px;
        line-height: 200%;
        color: #EAEAEA;

    }
}

</style>